import { ILocation } from '../../types/redux';
import { ELocationActions, ISetPageAction } from '../../actions/location';

export const defaultRegion: ILocation = {
  subdomain: 'www',
  path: '',
  page: 1,
  redirectUrl: null,
};

export function location(state: ILocation = defaultRegion, action: ISetPageAction) {
  switch (action.type) {
    case ELocationActions.setPage: {
      return {
        ...state,
        ...action.payload,
      };
    }
    default:
      return state;
  }
}
